import React, { useState } from "react";

import { Col, Container, Row } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";

import classNames from "classnames";
import dayjs from "dayjs";
import { isNil } from "lodash";

import { DateFormat, formatStringToDateFormat } from "@util/index";

import DateRangePickerModal from "./DateRangePickerModal";

// Import the datepicker styles
import styles from "./DateFilter.module.scss";

interface DateFilterProps {
  setDateRange: React.Dispatch<React.SetStateAction<{ startDate: string | null; endDate: string | null }>>;
}

const calculateDateRange = (daysAgo: number) => {
  const today = dayjs();
  const startDate = formatStringToDateFormat(
    today.subtract(daysAgo, "day").startOf("day").toISOString(),
    DateFormat.YYYY_MM_DD_DASH_WITH_TIME,
  );
  const endDate = formatStringToDateFormat(today.endOf("day").toISOString(), DateFormat.YYYY_MM_DD_DASH_WITH_TIME);
  return { startDate, endDate };
};

const DateFilter: React.FC<DateFilterProps> = ({ setDateRange }) => {
  // Options for predefined date ranges
  const options = [
    { key: "Last 7 days", value: 7 },
    { key: "Last 3 months", value: 90 },
    { key: "Last 6 months", value: 180 },
    { key: "All time", value: 0 },
    { key: "Custom", value: null },
  ];

  const [selectedKey, setSelectedKey] = useState<string>("All time");
  const [showModal, setShowModal] = useState(false);

  const handleOptionSelect = (value: number | null, key: string) => {
    setSelectedKey(key);
    if (isNil(value)) {
      setShowModal(true);
    } else if (value !== 0) {
      const { startDate, endDate } = calculateDateRange(value);
      setDateRange({ startDate, endDate });
    } else {
      setDateRange({ startDate: null, endDate: null });
    }
  };

  const handleApplyDateRange = (startDate: string, endDate: string) => {
    setDateRange({
      startDate: startDate,
      endDate: endDate,
    });
  };

  const getDropdownToggleText = () => {
    return selectedKey;
  };

  return (
    <Container fluid className="d-inline">
      <Row>
        <Col>
          <Dropdown>
            <Dropdown.Toggle
              size="sm"
              className={classNames(styles[!selectedKey ? "dropdown-toggle" : "dropdown-toggle-active"])}
            >
              {getDropdownToggleText()}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {options.map((option) => (
                <Dropdown.Item key={option.key} onClick={() => handleOptionSelect(option.value, option.key)}>
                  {option.key}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>

            <DateRangePickerModal show={showModal} onHide={() => setShowModal(false)} onApply={handleApplyDateRange} />
          </Dropdown>
        </Col>
      </Row>
    </Container>
  );
};

export default DateFilter;
